import { render } from "./Table-Simple.vue?vue&type=template&id=5ff3ee6e&scoped=true"
import script from "./Table-Simple.vue?vue&type=script&lang=js"
export * from "./Table-Simple.vue?vue&type=script&lang=js"

import "./Table-Simple.vue?vue&type=style&index=0&id=5ff3ee6e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff3ee6e"]])

export default __exports__